import { memo, useState } from 'react'
import { useLocalStorage } from 'usehooks-ts'

const LearningModal: React.FC = memo(() => {
  const [dontShowAgain, setDontShowAgain] = useLocalStorage(
    'learningModalDontShowAgain',
    false,
  )

  const [isOpen, setIsOpen] = useState(!dontShowAgain)

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleOkClick = () => {
    if (dontShowAgain) {
      setDontShowAgain(true)
    }
    handleClose()
  }

  if (!isOpen) {
    return null
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[99999]">
      <div className="tc-mv-blur rounded-regular p-6 max-w-lg w-full mx-4">
        <h2 className="text-white text-xl font-semibold mb-4">
          Heads up - your twin learns from you
        </h2>
        <p className="text-white mb-6">
          Your digital twin learns from your conversations. When you share
          something new or clarify details, its knowledge updates automatically
          so it stays accurate.
        </p>
        <div className="mb-4 flex items-center gap-2">
          <input
            type="checkbox"
            id="dont-show-again"
            checked={dontShowAgain}
            onChange={e => setDontShowAgain(e.target.checked)}
            className="w-4 h-4 cursor-pointer"
            data-testid="learning-modal-dont-show-again-checkbox"
          />
          <label
            htmlFor="dont-show-again"
            className="text-white text-sm cursor-pointer"
          >
            Don't show again
          </label>
        </div>
        <div className="flex justify-end">
          <button
            onClick={handleOkClick}
            className="btn btn-primary min-w-32"
            data-testid="learning-modal-ok-btn"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  )
})

export { LearningModal }
